import { Package } from '@shared/types';

let lastPushedEvent: { event: string; data: string } | null = null;

export const pushToDataLayer = (event: string, data: any) => {
  window.dataLayer = window.dataLayer || [];

  const dataString = JSON.stringify(data);
  if (lastPushedEvent && lastPushedEvent.event === event && lastPushedEvent.data === dataString) {
    return;
  }

  lastPushedEvent = { event, data: dataString };
  window.dataLayer.push({ event, ...data });
};

export const clearEcommerce = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
};

export const formatServiceItem = (service: any, variant?: string) => ({
  item_id: service.id,
  // Prioritize specific English fields, fallback to generic name
  item_name: service.nameEn || service.name_en || service.serviceNameEn || service.name,
  item_category: 'Service',
  location_id: 'Tallinn',
  ...(variant && { item_variant: variant }),
});
export const formatPackageItem = (pkg: Package, variant?: string) => ({
  item_id: pkg.id,
  item_name: pkg.name,
  item_category: 'Package',
  location_id: 'Tallinn',
  ...(variant && { item_variant: variant }),
});

export const formatSessionBundleItem = (
  sessionBundle: any,
  type: 'Subscription' | 'Session Bundle' | 'Promotion' | 'Gift Card',
  overridePrice?: number
) => ({
  item_id: sessionBundle.id || 'GIFT_CARD_General',
  item_name: sessionBundle.name || 'Gift Card',
  item_category: type,
  value: overridePrice !== undefined ? overridePrice : sessionBundle.price,
});
